// extracted by mini-css-extract-plugin
export default {"button":"Button_button__tk-Kx","loader":"Button_loader__s6uS9","cell":"Button_cell__nXiT9"};